// clearance-results.js
import { clearSvgViews, renderSvgViews } from './clearance-results-svg.js';
import { initScene, isSceneInitialized, updateSceneSimple, resetView } from './clearance-results-3d.js';
import { runCollisionResults } from './clearance-req.js';
import { initReport } from './clearance-report.js';

let currentFrameIndex = 0;
let framesGlobal = [];
let formValuesGlobal = {};

/**
 * Initialize event handlers for frame navigation and initi 3d
 * Called from js on page load.
 */
export function initResults() {
   // collision frame navigation
   $('#prevCollisionBtn').on('click', () => {
      if (currentFrameIndex > 0) {
         showFrame(currentFrameIndex - 1);
      }
   });

   $('#nextCollisionBtn').on('click', () => {
      if (currentFrameIndex < framesGlobal.length - 1) {
         showFrame(currentFrameIndex + 1);
      }
   });

   // Click a table row → jump to that frame
   $('#sweepBlocksTable tbody').on('click', 'tr', function () {
      const idx = $(this).data('frame-index');
      if (typeof idx === 'number' && idx >= 0 && idx < framesGlobal.length) {
         showFrame(idx);
      }
   });

   let playInterval = null;

   $('#playBtn').on('click', function () {
      if (playInterval) {
         clearInterval(playInterval);
         playInterval = null;
         $(this).text('▶ Play');
      } else {
         $(this).text('⏸ Pause');
         playInterval = setInterval(() => {
            if (currentFrameIndex < framesGlobal.length - 1) {
               showFrame(currentFrameIndex + 1);
            } else {
               clearInterval(playInterval);
               playInterval = null;
               $('#playBtn').text('▶ Play');
            }
         }, 300); // 300 ms per frame, adjust for speed
      }
   });

   // show/hide sweep details collapse
   const $toggleBtn = $('#sweepBlocksCollapseBtn');
   const $collapse = $('#sweepBlocksCollapse');

   $toggleBtn.on('click', function (e) {
      e.preventDefault();

      // Toggle visibility manually
      $collapse.toggle();

      // Update button text + icon depending on new state
      if ($collapse.is(':visible')) {
         $toggleBtn.html('<i class="fas fa-chevron-up me-1"></i> Hide Sweep Details');
      } else {
         $toggleBtn.html('<i class="fas fa-chevron-down me-1"></i> Show Sweep Details');
      }
   });

   $('#resetViewBtn').on('click', () => {
      resetView();
   });

   initReport();
}

/* * Update the collision result display with new data.
 * This function updates the SVG views, renders the summary panel,
 * and displays the collision frames based on the provided result.
 * @param {Object} formValues - The form values used for the collision check
 * @param {Object} result - The collision result object containing metadata and frames
 */
export function updateCollisionResult(formValues, result) {
   // Called after a new set of results are received from the API (post Run Anlaysis button click)
   formValuesGlobal = formValues; // Store for later use

   const { meta, results: frames } = result;
   //console.log('Collision result :', result);

   // To ensure that the 3D scene renders, make sure that the 3D tab is shown first
   const tabEl = document.querySelector('#threeD-tab');
   const tab = new bootstrap.Tab(tabEl);
   tab.show();
   // then initialize the 3D scene if not already done
   const threeSceneInitialized = isSceneInitialized();
   if (!threeSceneInitialized) {
      initScene('threeContainer');
   }

   // Render the summary panel with stats and block details
   renderSweepSummaryPanel(meta, frames);
   if (frames.length > 0) {
      renderSweepBlocks(frames);
      $('#sweepBlocksCollapse').removeClass('d-none');

      // Default: summary mode
      $('input[name="sweepViewMode"]')
         .off('change')
         .on('change', function () {
            const mode = $(this).val();
            if (mode === 'summary') {
               renderSweepBlocks(frames);
            } else if (mode === 'collisions') {
               renderCollisionFrames(frames);
            } else if (mode === 'all') {
               renderAllFrames(frames);
            }
         });
   }

   if (frames.length > 0) {
      $('#collision-nav-controls').removeClass('d-none');
      framesGlobal = frames;

      // Setup slider range
      $('#frameSlider')
         .attr('min', 0)
         .attr('max', frames.length - 1)
         .val(currentFrameIndex);
      $('#frameSliderLabel').text(`Frame ${currentFrameIndex + 1} / ${frames.length}`);

      // Slider interaction
      $('#frameSlider')
         .off('input')
         .on('input', function () {
            const idx = parseInt($(this).val(), 10);
            if (!isNaN(idx)) {
               showFrame(idx);
            }
         });

      // find the first collision frame
      const firstCollisionIndex = frames.findIndex((f) => f.isCollision);
      if (firstCollisionIndex >= 0) {
         currentFrameIndex = firstCollisionIndex; // start at first collision frame
      } else {
         currentFrameIndex = 0; // no collisions, start at first frame
      }
      // Show the first frame
      showFrame(currentFrameIndex);
   }
}

/**
 * Load a frame by index and render its views.
 * called from the collision frame navigation buttons.
 */
function showFrame(index) {
   // --- Guard + state
   const frame = framesGlobal[index];
   if (!frame) return;
   currentFrameIndex = index;

   // --- Build status text
   const collisionBadge = frame.isCollision ? '🚫 Collision' : '✅ Clear';
   const pivotText = frame.internalAngle > 0 ? ` , Pivot: ${frame.internalAngle}°` : '';
   const infoText =
      `${collisionBadge} frame ${index + 1} of ${framesGlobal.length} ` +
      `Joint: ${frame.joint} (Yaw: ${frame.yaw}°, Pitch: ${frame.pitch}°, ` +
      `Roll: ${frame.roll}° ${pivotText})`;

   // --- Update info text
   const infoEl = document.getElementById('collisionFrameInfo');
   infoEl.textContent = infoText;

   // --- Subtle pop/fade animation (no CSS needed)
   try {
      // Cancel any in-flight animation by calling animate() again
      infoEl.animate(
         [
            { transform: 'translateY(-2px)', opacity: 0.25 }, // quick lift + faint
            { transform: 'translateY(0)', opacity: 1.0 }, // settle back
         ],
         {
            duration: 350,
            easing: 'ease-out',
         }
      );
   } catch (e) {
      // If WAAPI isn’t supported, just ignore — no-op fallback
      // console.debug('Animation not supported, skipping effect.');
   }

   // --- Enable/disable nav buttons
   $('#prevCollisionBtn').prop('disabled', index === 0);
   $('#nextCollisionBtn').prop('disabled', index === framesGlobal.length - 1);

   // --- Update 3D scene (if available)
   if (Array.isArray(frame.boxes) && frame.boxes.length > 0) {
      const { boxes, collisionPairs } = frame;
      updateSceneSimple(boxes, collisionPairs); // draw current frame in 3D
   } else {
      $('#threeContainer').html('<p class="text-muted">3D view not available for this frame.</p>');
   }

   // --- Update SVG plan views (cached or single-frame fetch)
   ensureFrameSVG(index);

   // --- Sync slider + label
   $('#frameSlider').val(index);
   $('#frameSliderLabel').text(`Frame ${index + 1} / ${framesGlobal.length}`);
}

// Ensure the SVG for a specific frame is loaded and rendered.
async function ensureFrameSVG(index) {
   const frame = framesGlobal[index];
   if (!frame) return;
   clearSvgViews('svgPlan');
   // SVG Already cached or generated? Use it
   if (frame.svg) {
      renderSvgViews(frame.svg, 'svgPlan');
      return;
   }

   // Fetch only this yaw/pitch/roll/pivot
   const jointIdx = frame.joint; // Joint index for the sweep
   const yaw = frame.yaw;
   const pitch = frame.pitch;
   const roll = frame.roll;
   // check if pivot is defined, otherwise use default
   let pivot;
   if (frame.internalPivot) {
      pivot = frame.internalAngle; // capture pivot angle
   } else pivot = 0;
   const singleSweepOpts = {
      jointIdx,
      yaw,
      pitch,
      roll,
      pivot,
   };

   const sweepOpts = {
      sweepId: 'single',
      svgPath: false,
      exitOnFirstCollision: false,
      pivotModes: [pivot],
      saveAllSvg: true,
   };

   const response = await runCollisionResults(formValuesGlobal, sweepOpts, singleSweepOpts);
   const results = response.results;
   const meta = response.meta;
   if (!response || meta.totalFrames < 1 || results.length === 0) {
      console.error('No frames returned for the single analysis:', result);
      $('#status').text('Failed to load frame SVG.');
      return;
   }
   if (results.length > 1) {
      console.log('Multiple frames returned for single analysis, using first frame only:', results.length);
   }

   // Assume first result
   const fullFrame = results[0];

   // Store svg into framesGlobal[i] (cache)
   frame.svg = fullFrame.svg;
   renderSvgViews(frame.svg, 'svgPlan');
}

async function runSingleAnalysis(joint, yaw, roll, pitch, pivot) {
   // Use the api to generate a single frame with the specified yaw, pitch, roll, and pivot to get the SVG
   const sweepOpts = {
      name: 'single',
      yawModes: [yaw],
      pitchModes: [pitch],
      rollModes: [roll],
      pivotModes: [pivot],
      saveAllSvg: true,
   };

   try {
      const result = await runCollisionResults(formValuesGlobal, sweepOpts);
      if (result) {
         updateCollisionResult(formValuesGlobal, result);
      }
   } catch (err) {
      $('#status').text('Failed.');
      console.error(err);
   } finally {
   }
}

/**
 * Populate the #results-summary-panel with a summary of sweep results.
 * @param {Object} meta - Metadata from the sweep result
 * @param {Array} frames - All sweep frames
 */

export function renderSweepSummaryPanel(meta, frames) {
   const $panel = $('#results-summary-panel');
   $panel.removeClass('d-none alert-soft-danger alert-soft-success').empty();

   const totalFrames = frames.length;
   const collisionFrames = frames.filter((f) => f.isCollision);
   const hasCollision = collisionFrames.length > 0;
   const firstCollision = collisionFrames[0];
   const noCollisionFrames = totalFrames - collisionFrames.length;

   // Determine yaw range
   const yaws = frames.map((f) => f.yaw).filter((y) => typeof y === 'number');
   const yawMin = Math.min(...yaws);
   const yawMax = Math.max(...yaws);
   let yawText = 'N/A';
   if (yawMin < 0 && yawMax > 0) yawText = `center (0°) → left ${yawMin}° & right ${yawMax}°`;
   else if (yawMax > 0) yawText = `center (0°) → right ${yawMax}°`;
   else if (yawMin < 0) yawText = `center (0°) → left ${yawMin}°`;

   // Pitch info
   const pitches = [...new Set(frames.map((f) => f.pitch))];
   const pitchText =
      pitches.length === 1 ? `${pitches[0]}° (constant)` : `${Math.min(...pitches)}° → ${Math.max(...pitches)}°`;

   // Roll info, note this is joint specific though
   const rolls = [...new Set(frames.map((f) => f.roll))];
   const rollText = rolls.length === 1 ? `${rolls[0]}° (constant)` : `${Math.min(...rolls)}° → ${Math.max(...rolls)}°`;

   $panel.addClass(hasCollision ? 'alert-soft-danger' : 'alert-soft-success');

   // Create summary list
   const $list = $('<ul class="mb-0"></ul>');

   // Colored status message
   const statusHTML = hasCollision
      ? '<span class="text-danger">🚫 Collisions detected</span>'
      : '<span class="text-success">✅ Clearance verified</span>';
   $list.append(`<li><strong>Status:</strong> ${statusHTML}</li>`);

   // Basic sweep details
   $list.append(`<li><strong>Total Frames:</strong> ${totalFrames}</li>`);
   $list.append(
      `<li><strong>Collision Frames:</strong> ${collisionFrames.length} (${(
         (collisionFrames.length / totalFrames) *
         100
      ).toFixed(1)}%)</li>`
   );
   $list.append(`<li><strong>Yaw Sweep:</strong> ${yawText}</li>`);
   $list.append(`<li><strong>Pitch Sweep:</strong> ${pitchText}</li>`);
   $list.append(`<li><strong>Roll Sweep:</strong> ${rollText}</li>`);
   // First collision detail if exists
   if (firstCollision) {
      const { yaw, pitch, roll, collisionPairs, joint } = firstCollision;
      const pairText = collisionPairs.map((p) => `${p.unitA} ${p.boxAId} ↔ ${p.unitB} ${p.boxBId}`).join(', ');
      $list.append(`<li><strong>First Collision:</strong> Yaw ${yaw}°, Pitch ${pitch}°, Roll ${roll}°</li>`);
      $list.append(`<li><strong>Between:</strong> ${pairText} at joint ${joint}</li>`);
   }

   $panel.append($list);
}

/**
 * Renders the sweep blocks into the #sweepBlocksTable.
 * Each block represents a continuous segment of frames with the same collision status and pitch.
 * @param {Array} frames - The array of frames from the sweep result
 */
function renderSweepBlocks(frames) {
   const blocks = computeSweepBlocks(frames);
   const $tableBody = $('#sweepBlocksTable tbody');
   $tableBody.empty();

   blocks.forEach((block, i) => {
      const isCollision = block.type === 'collision';
      const statusLabel = isCollision
         ? '<span class="text-danger">🚫 Collision</span>'
         : '<span class="text-success">✅ Clear</span>';

      const yawText = block.fromYaw === block.toYaw ? `${block.fromYaw}°` : `${block.fromYaw}° → ${block.toYaw}°`;
      const pitchText =
         block.fromPitch === block.toPitch ? `${block.fromPitch}°` : `${block.fromPitch}° → ${block.toPitch}°`;
      const rollText = block.fromRoll === block.toRoll ? `${block.fromRoll}°` : `${block.fromRoll}° → ${block.toRoll}°`;
      // Create a table row for each block
      const row = `
         <tr data-frame-index="${block.startIndex}">
            <td>${i + 1}</td>
            <td>${statusLabel}</td>
            <td>${block.startIndex + 1}–${block.endIndex + 1} (${block.length})</td>
            <td>${block.joint}</td>
            <td>${yawText}</td>
            <td>${pitchText}</td>
            <td>${rollText}</td>
         </tr>`;

      $tableBody.append(row);
   });
}

/**
 * Renders only the collision frames into the #sweepBlocksTable.
 * Each row represents a single collision frame.
 * @param {Array} frames - The array of frames from the sweep result
 */
function renderCollisionFrames(frames) {
   const $tableBody = $('#sweepBlocksTable tbody');
   $tableBody.empty();

   const collisionFrames = frames.filter((f) => f.isCollision);
   if (collisionFrames.length === 0) {
      $tableBody.append(`<tr><td colspan="7" class="text-muted">No collision frames detected</td></tr>`);
      return;
   }

   collisionFrames.forEach((frame, i) => {
      const statusLabel = '<span class="text-danger">🚫 Collision</span>';
      const yawText = `${frame.yaw}°`;
      const pitchText = `${frame.pitch}°`;
      const rollText = `${frame.roll}°`;

      const row = `
         <tr data-frame-index="${frame.index ?? i}">
            <td>${i + 1}</td>
            <td>${statusLabel}</td>
            <td>${frame.frameId ?? frame.index ?? i + 1}</td>
            <td>${frame.joint}</td>
            <td>${yawText}</td>
            <td>${pitchText}</td>
            <td>${rollText}</td>
         </tr>`;

      $tableBody.append(row);
   });
}

/**
 * Renders all frames into the #sweepBlocksTable.
 * Each row represents one frame (collision or clear).
 * @param {Array} frames - The array of frames from the sweep result
 */
function renderAllFrames(frames) {
   const $tableBody = $('#sweepBlocksTable tbody');
   $tableBody.empty();

   frames.forEach((frame, i) => {
      const statusLabel = frame.isCollision
         ? '<span class="text-danger">🚫 Collision</span>'
         : '<span class="text-success">✅ Clear</span>';
      const yawText = `${frame.yaw}°`;
      const pitchText = `${frame.pitch}°`;
      const rollText = `${frame.roll}°`;

      const row = `
         <tr data-frame-index="${i}">
            <td>${i + 1}</td>
            <td>${statusLabel}</td>
            <td>${frame.frameId ?? i + 1}</td>
            <td>${frame.joint}</td>
            <td>${yawText}</td>
            <td>${pitchText}</td>
            <td>${rollText}</td>
         </tr>`;

      $tableBody.append(row);
   });
}

/**
 * Computes continuous blocks of frames with the same collision status and pitch.
 * Each block contains the start and end indices, yaw range, and length.
 * @param {Array} frames - The array of frames from the sweep result
 * @returns {Array} - An array of block objects with type, pitch, startIndex, endIndex, yaw range, and length
 */
function computeSweepBlocks(frames) {
   const blocks = [];

   if (frames.length === 0) return blocks;

   let currentType = frames[0].isCollision ? 'collision' : 'clear';
   let currentJoint = frames[0].joint;
   let minYaw = frames[0].yaw;
   let maxYaw = minYaw;
   let minPitch = frames[0].pitch;
   let maxPitch = minPitch;
   let minRoll = frames[0].roll;
   let maxRoll = minRoll;
   let start = 0;

   for (let i = 1; i < frames.length; i++) {
      const f = frames[i];
      const type = f.isCollision ? 'collision' : 'clear';
      const joint = f.joint;

      // break blocks if collision type  or joint changes
      if (joint != currentJoint || type !== currentType) {
         // Push the completed block
         blocks.push({
            type: currentType,
            joint: currentJoint,
            startIndex: start,
            endIndex: i - 1,
            fromYaw: minYaw,
            toYaw: maxYaw,
            fromRoll: minRoll,
            toRoll: maxRoll,
            fromPitch: minPitch,
            toPitch: maxPitch,
            length: i - start,
         });

         // Reset for next block
         start = i;
         currentType = type;
         currentJoint = joint;
         minPitch = f.pitch;
         maxPitch = f.pitch;
         minRoll = f.roll;
         maxRoll = f.roll;
         minYaw = f.yaw;
         maxYaw = f.yaw;
      } else {
         if (f.yaw < minYaw) minYaw = f.yaw;
         if (f.yaw > maxYaw) maxYaw = f.yaw;
         if (f.pitch < minPitch) minPitch = f.pitch;
         if (f.pitch > maxPitch) maxPitch = f.pitch;
         if (f.roll < minRoll) minRoll = f.roll;
         if (f.roll > maxRoll) maxRoll = f.roll;
      }
   }

   // Final block
   blocks.push({
      type: currentType,
      joint: currentJoint,
      startIndex: start,
      endIndex: frames.length - 1,
      fromYaw: minYaw,
      toYaw: maxYaw,
      fromPitch: minPitch,
      toPitch: maxPitch,
      fromRoll: minRoll,
      toRoll: maxRoll,
      length: frames.length - start,
   });

   return blocks;
}
